import React from 'react'
import css from './styles.css'
import { connect } from 'react-redux'
import * as actions from '../../actions/settings'

const mapStateToProps = (state, ownProps) => {
  return {
    ...state.settings
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setCurrency: (val) => {
      dispatch(actions.setCurrency(val))
    }
  }
}

const CurrencyMenu = props => {
  return (
    <div className={css.dropdownMenu}>
      <ul>
        <li className={props.currency === 'cad' ? css.active : ''} onClick={() => props.setCurrency('cad')}>CAD</li>
        <li className={props.currency === 'usd' ? css.active : ''} onClick={() => props.setCurrency('usd')}>USD</li>
      </ul>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(CurrencyMenu)



// WEBPACK FOOTER //
// ./src/components/currency-menu/index.js